<template>
  <nuttrema-layout-west-slide width="35%" max-width="45em">
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: _get(meta, 'navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <nuttrema-layout-east-block>
      <nuttrema-layout-west-three-vertical>
        <div v-if="_has(meta, 'title')" slot="top-center" class="top--center__title">
          <span>{{ $t(_get(meta, 'title')) }}</span>
        </div>
        <template slot="center">
          <nuttrema-loader v-if="PersonDetails.fetching || PersonLifeStages.fetching || RegionalAndLanguageAll.fetching"></nuttrema-loader>
          <form-participant-personal-information-cred
             v-else
             theme="west-top"
             labelPosition="top"
            :edit="true"
            :PersonDetails="PersonDetails"
            :PersonLifeStages="PersonLifeStages"
            :RegionalAndLanguageAll="RegionalAndLanguageAll"
            @submit="handleEventSubmit"
            @cancelCreate="handleEventCancelCreate">
          </form-participant-personal-information-cred>
        </template>
      </nuttrema-layout-west-three-vertical>
    </nuttrema-layout-east-block>

  </nuttrema-layout-west-slide>
</template>

<script>
import { get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import { PERSON_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import FormParticipantPersonalInformationCred from './form-participant-personal-information-cred';

export default {
  name: 'page-participant-personal-information-add',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: -1,
    },
    type: {
      required: false,
      default: PERSON_KEYS.participant,
    },
  },
  components: {
    NuttremaLoader,
    NuttremaLayoutEastBlock,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
    FormParticipantPersonalInformationCred,
  },
  computed: {
    ...mapGetters([
      'RegionalAndLanguageAll',
    ]),
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
    PersonLifeStages() {
      return this.$store.getters.PersonLifeStages(this.type);
    },
  },
  methods: {
    ...mapActions([
      'AddPerson',
    ]),
    handleEventCancelCreate() {
      this.onCancelEvent();
    },
    handleEventSubmit(payload) {
      this.AddPerson({
        id: this.id,
        type: this.type,
        payload,
      }).then(() => {
        this.successNotification({ label: 'label.participant' });
        const id = get(this.PersonDetails, 'data.id');
        this.onSuccessEvent({ id });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
  created() {
    this.$store.dispatch('GetRegionalAndLanguageAll', { language_app_support: true, measurement_system_optional: true });
    this.$store.dispatch('GetPersonDetails', { id: this.id });
    this.$store.dispatch('GetPersonLifeStages', { type: this.type });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearRegionalAndLanguageAll');
    this.$store.dispatch('ClearPersonLifeStages', { type: this.type });
    this.$store.dispatch('ClearPersonDetails', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-cred/page-participant-personal-information-add.vue